import { Filter } from '../components/Modal/TaskFiltersModal';
import { WorkspaceViewColumn } from './WorkspaceViewColumn';
import { WorkspaceViewSort } from './WorkspaceViewSortBy';

export type WorkspaceView = {
  id: number;
  publicId: string;
  name: string;
  workspaceId: number;
  group: WorkspaceViewGroup;
  representation: WorkspaceViewRepresentation;
  entityType: WorkspaceViewEntityType;
  groupBy: string | undefined;
  sortBy: WorkspaceViewSort | undefined;
  filters: Filter[] | undefined;
  columns: WorkspaceViewColumn | undefined;
  orderIndex: number | undefined;
  default: boolean | undefined;
  createdAt: Date;
  updatedAt: Date;
};

export enum WorkspaceViewGroup {
  triage = 'triage',
  backlog = 'backlog',
  epics = 'epics',
  planning = 'planning',
  sprint = 'sprint',
  kanban = 'kanban',
  archive = 'archive',
}

export enum WorkspaceViewRepresentation {
  table = 'table',
  kanban = 'kanban',
}

export enum WorkspaceViewEntityType {
  epic = 'epic',
  task = 'task',
}

export const WorkspaceViewGroupUtils = {
  getTitle(item: WorkspaceViewGroup): string {
    switch (item) {
      case WorkspaceViewGroup.triage:
        return 'Triage';
      case WorkspaceViewGroup.backlog:
        return 'Backlog';
      case WorkspaceViewGroup.epics:
        return 'Epics';
      case WorkspaceViewGroup.planning:
        return 'Planning';
      case WorkspaceViewGroup.sprint:
        return 'Sprint';
      case WorkspaceViewGroup.kanban:
        return 'Kanban';
      case WorkspaceViewGroup.archive:
        return 'Archive';
    }
  },
};
